<template>
  <div>
    <OrgTab
        :items="items"
        :columns="columnsFed"
        :isCalled="isCalledFed"
        :selectedValue="selectedItem"
        @editItem="showEditDialog"
        @updateData="loadItems"
        v-model="selectedItem"
        :captionSpr="captionFed"
        :urls="urls"
        :captionTab="captiontable"
        ref="OrgTab"
    >
    </OrgTab>

    <modal-ekp modalName="editModal" draggable=".window-header" v-model="modalEditOpened"
               :adaptive="true" :resizable="true" title="Редактирование организации" :width="'60%'">
      <div class="d-block">
        <b-input-group prepend="Наименование" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите наименование" v-model="selectedItem.nameOrg"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.nameOrg">Указано пустое наименование</b-form-invalid-feedback>

        <b-input-group prepend="Краткое наименование" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите краткое наименование" v-model="selectedItem.shortName"/>
        </b-input-group>

        <b-input-group prepend="Адрес организации" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите адрес" v-model="selectedItem.adress"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.adress">Указан пустой адрес</b-form-invalid-feedback>

        <b-input-group prepend="Телефон федерации" class="mt-1" size="sm">
          <b-input-group-append>
            <the-mask class="px-1" style="width: 100%" type="text"
                      :mask="['+7 (###) ###-####', '+7 (###) ###-####']"
                      v-model="selectedItem.phoneNumber"
                      placeholder="+7(999) 999-9999"/>
          </b-input-group-append>
        </b-input-group>

        <b-input-group prepend="email" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите электронный адрес" v-model="selectedItem.email"/>
        </b-input-group>

        <b-input-group prepend="ИНН" class="mt-1" size="sm">
          <b-form-input type="text" v-model="selectedItem.inn" placeholder="Укажите ИНН"
                        @keypress="validateNumber"
                        maxLength="12"
                        aria-describedby="input-live-help input-live-feedback"/>
        </b-input-group>

        <b-row>
          <b-col sm="6" class="text-left">
            <b-button class="mt-1 mr-1" variant="outline-primary" @click="showDocument">Шаблоны</b-button>
          </b-col>
          <b-col sm="6" class="text-right">
            <b-button class="mt-1 mr-1" variant="outline-primary" @click="saveOrg">Сохранить</b-button>
            <b-button class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить
            </b-button>
          </b-col>
        </b-row>
      </div>
    </modal-ekp>

    <modal-ekp modalName="docModal" draggable=".window-header" v-model="modalDocumentOpened"
               :adaptive="true" :resizable="true" title="Шаблоны" :width="'50%'">
      <div class="d-block">
        <FileDoc :apipath="'org/doc'" :pathStr="'docs'" :columnsDoc="columnsDoc"
                 :ekp_id="selectedItem.id" :nameDoc="'шабл'" :checkDate="false"
                 @closeDialog="modalDocumentOpened = false" :fileType="'.docx'">
        </FileDoc>
      </div>
    </modal-ekp>

  </div>
</template>
<script>
import OrgTab from '@/components/TabSpr.vue'
import http from '@/http-common'
import FileDoc from '@/components/FileDocument.vue'
import ModalEkp from "./ekpForm/ModalFormEkp"
import global from '@/utils/global'

export default {
  name: 'Organization',
  components: {OrgTab, FileDoc, ModalEkp},
  props: {
    isCalledFed: {
      type: Boolean,
      default: false,
    },
    selectedValue: {
      type: Object,
      default: null
    },
    columnsFed: {
      type: Array,
      default: () => [
        {key: 'nameOrg', label: 'Наименование'},
        {key: 'shortName', label: 'Краткое наименование'},
        {key: 'adress', label: 'Адрес'},
        {key: 'phoneTel', label: 'Телефон', firstClass: 'width10'},
        {key: 'email', label: 'email'},
        {key: 'inn', label: 'ИНН'},
        {key: 'edit_field', label: '', firstClass: 'width10'}
      ],
    }
  },
  data() {
    return {
      captiontable: 'Организации',
      items: [],
      selected: [],
      captionFed: {
        name: 'Организация',
        nameR: 'организацию'
      },
      urls: {
        save: '/org/save',
        delete: '/org/delete',
      },
      selectedItem: {
        id: null,
        nameOrg: '',
        shortName: '',
        adress: '',
        inn: '',
        phoneNumber: '',
        email: ''
      },
      modalEditOpened: false,
      validValue: {
        nameOrg: true,
        adress: true,
        form: true,
      },
      modalDocumentOpened: false,
      documents: [],
      columnsDoc: [
        {key: 'nameDoc', label: 'Наименование документа'},
        {key: 'commentDoc', label: 'Комментарий документа'},
        {key: 'edit_field', label: ''}
      ]
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    validateNumber(value) {
      global.validateNumber(value);
    },
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.nameOrg || this.selectedItem.nameOrg === '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.adress || this.selectedItem.adress === '') {
        this.validValue.adress = false;
        this.validValue.form = false;
      }
    },
    loadItems() {
      var vm = this;
      http.get('/org/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    showEditDialog() {
      if (!this.isCalledFed) {
        this.modalEditOpened = !this.modalEditOpened;
      } else {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      }
    },
    rowSelected(items) {
      this.selected = items;
      //var rec = this.selectedItem;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      //this.selectedItem = rec;
      this.$emit('input', this.selectedItem)
    },
    saveOrg() {
      if (!this.isCalledFed) {
        this.checkForm();
        if (this.validValue.form) {
          this.modalEditOpened = false;
          this.$refs.OrgTab.save(this.selectedItem);
        }
      } else {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      }
    },
    showDocument() {
      this.showOper = false;
      for (var key in this.validDocument) {
        this.validDocument[key] = true;
      }
      //this.rowSelected([rec]);
      this.loadDocuments(this.selectedItem.id);
      this.modalDocumentOpened = !this.modalDocumentOpened
    },
    loadDocuments(id) {
      var vm = this;
      http.get('/org/doc/' + id)
      .then((response) => {
        if (response.data && response.data !== "") {
          vm.documents = response.data;
        } else {
          vm.documents = []
        }
      })
      .catch((error) => console.log(error.response.data));
    },
  }
}
</script>
